import React from 'react';
import { Line } from 'react-chartjs-2';
import { Pivot } from '../models/pivot';

export interface GraficoEvolucaoProps {
  pivot: Pivot;
  medida: string;
}

export const GraficoEvolucao = ({ pivot, medida }: GraficoEvolucaoProps) => {

  const colors = ['#1976d2', '#04C4D9', '#038C33', '#F29F05', '#D96704', '#BF2315', '#162440', '#93B4D7', '#385187', '#027A7B',
    '#212226', '#1E4040', '#3A8C7D', '#71D99E'];

  var dataSets = pivot.rows.map((x, i) => {
    return {
      type: 'line',
      label: x.sigla ?? x.name,
      borderColor: colors[i],
      backgroundColor: colors[i], //'rgb(54, 162, 235)',
      borderWidth: 2,
      fill: false,
      data: x.cols.map(y => y.values[medida])
    };
  });

  var labels: string[] = pivot.rows[0].cols.map(x => x.data);

  var grafico = {
    labels: labels,
    datasets: dataSets,
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
  };

  return <>
    <Line data={grafico} options={options} height={450} legend={{ fullWidth: false }} ></Line>
  </>;
};
